module.exports = __webpack_public_path__ + "img/img_question-mark@2x.f8e72bf4.png";